import styled from "@emotion/styled";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

export const StyledInputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  gap: ${({ theme }) => theme.spacing["3"]};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  border: 1px solid ${({ theme }) => theme.colors.border.input.default.default};
  background: ${({ theme }) => theme.colors.background.input.default.default};
  min-height: 48px;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;

  --extra-padding-left: ${({ theme }) => theme.spacing[5]};
  --extra-padding-right: ${({ theme }) => theme.spacing[5]};
  --extra-padding-bottom: ${({ theme }) => theme.spacing[3]};
  --extra-padding-top: ${({ theme }) => theme.spacing[3]};

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.border.input.default.focused};
    background: ${({ theme }) => theme.colors.background.input.default.focused};
  }

  &:hover:not(:focus-within):not([aria-disabled="true"]) {
    border-color: ${({ theme }) => theme.colors.border.input.default.focused};
    background: ${({ theme }) => theme.colors.background.input.default.focused};
  }

  &[aria-disabled="true"] {
    cursor: text;
  }
`;

export const StyledInputArea = styled.div`
  flex: 1;
  width: 100%;
  min-width: 0; /* Allow shrinking */
  min-height: 46px;

  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const StyledExpand = styled.div`
  flex: 1;
  min-width: 0; /* Allow shrinking */
  width: 100%;

  /* Constrain the editor content */
  .ProseMirror {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    outline: none;
    border: none;
    background: transparent;
    word-wrap: break-word;
    overflow-wrap: break-word;
    text-align: left;
    cursor: text;

    /* Prevent horizontal scrolling */
    overflow-x: hidden;

    /* Allow multi-line but limit height with scrolling */
    max-height: 120px;
    overflow-y: auto;

    /* Hide scrollbar */
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  /* Style the MemCommonRichTextInput container directly */
  > div {
    width: 100%;
    min-width: 0;
  }
`;

export const StyledMentionPopoverContent = styled.div`
  background: ${({ theme }) => theme.colors.surface.menu};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  box-shadow: ${({ theme }) => theme.shadows.surface};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  min-width: 240px;
  max-width: 320px;
  max-height: 300px;
  overflow-y: auto;
  padding-block: ${({ theme }) => theme.spacing[3]};
  scrollbar-width: none;
  outline: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledMentionPopoverHeader = styled.div`
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[3]}`};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.24px;
`;

export const StyledMentionPopoverItem = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[3]}`};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes["text-s"]};
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.surface.paneHeader : "transparent"};

  &:hover {
    background: ${({ theme }) => theme.colors.surface.paneHeader};
  }
`;

/**
 * Invisible 0x0 anchor div positioned at the mention trigger rect. Serves as
 * the triggerRef for react-aria's Popover so it can position relative to the
 * mention character without us managing a floating-ui instance.
 */
export const StyledMentionAnchor = styled.div`
  position: fixed;
  width: 0;
  height: 0;
  pointer-events: none;
`;
